const styles = (theme) => ({
    tierCardContainer: {
        marginTop: '15px',
    },
});

export default styles;
